import React, { useState, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import { Link, useNavigate, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import moment from "moment";
import { toast } from "react-toastify";
import { api_url } from "../../helpers/apiHelpers";
import EditTransliteration from "./EditTransliteration";

const EditGPFNonRefundable = () => {
  const route = useParams().id;
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");
  const userName = localStorage.getItem("userName");

  useEffect(() => {
    if (userId === null || userId === "") {
      navigate("/sign_in");
    }
  }, []);

  const tabs = ["अर्जदाराची माहिती", "वेतनाचा तपशील", "भ.नि.नि.कपात तपशील"];
  const [toDate, setToDate] = useState(new Date());

  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    officeName: "",
    officeHeadDesignation: "",
    officeSerialNumber: "",
    approvingDepartmentName: "वित्त विभाग जिल्हा परिषद",
    submissionOffice: "",
    applicantName: "",
    designation: "",
    gpfNumber: "",
    salaryRange: "",
    baseSalary: "",
    reasonForAdvance: "",
    dob: new Date(),
    firstAppointmentDate: new Date(),
    retirementDate: new Date(),
    serviceDuration: "",
    salaryMonth: "",
    // Add bank details state

    bankName: "",
    branchName: "",
    ifscCode: "",
    accountNumber: "",
    mobileNumber: "",

    //
    basicPay: "",
    dearnessAllowance: "",
    houseRentAllowance: "",
    transportAllowance: "",
    permanentTravelAllowance: "",
    nps: "",
    dearnessDifference: "",
    seventhPayInstallment: "",
    washingAllowance: "",
    basicArrears: "",
    other1: "",
    other2: "",
    grossPayableSalary: "",
    professionTax: "",
    groupInsurance: "",
    bhininiVargani: "",
    festivalAdvance: "",
    dcps: "",
    npsDeduction: "",
    lic: "",
    gppatSanstha: "",
    arogyapatSanstha: "",
    gramsevakPatSanstha: "",
    groupInsuranceHomeLoan: "",
    receiptTicket: "",
    totalDeductions: "",
    netPaySalary: "",
  });
  const [formData2, setFormData2] = useState({
    officeName: "",
    officeHeadDesignation: "",
    officeSerialNumber: "",
    approvingDepartmentName: "वित्त विभाग जिल्हा परिषद",
    submissionOffice: "",
    applicantName: "",
    designation: "",
    gpfNumber: "",
    salaryRange: "",
    baseSalary: "",
    reasonForAdvance: "",
    dob: new Date(),
    firstAppointmentDate: new Date(),
    retirementDate: new Date(),
    serviceDuration: "",
    salaryMonth: "",
    // Add bank details state

    bankName: "",
    branchName: "",
    ifscCode: "",
    accountNumber: "",
    mobileNumber: "",

    //
    basicPay: "",
    dearnessAllowance: "",
    houseRentAllowance: "",
    transportAllowance: "",
    permanentTravelAllowance: "",
    dearnessDifference: "",
    seventhPayInstallment: "",
    washingAllowance: "",
    basicArrears: "",
    other1: "",
    other2: "",
    grossPayableSalary: "",
    professionTax: "",
    groupInsurance: "",
    bhininiVargani: "",
    festivalAdvance: "",
    lic: "",
    gppatSanstha: "",
    arogyapatSanstha: "",
    gramsevakPatSanstha: "",
    groupInsuranceHomeLoan: "",
    receiptTicket: "",
    totalDeductions: "",
    netPaySalary: "",
  });

  const [GPFNRData, setGPFNRData] = useState([]);
  const getGPFNRData = async () => {
    try {
      const response = await fetch(`${api_url}/api/users/get-gpfnr-data`, {
        method: "POST",
        body: JSON.stringify({
          userId,
        }),
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      });
      const result = await response.json();
      if (result.status === 201) {
        let singleData = result.result.find((item) => item._id === route);
        setGPFNRData(singleData);
      } else {
        setGPFNRData([]);
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  useEffect(() => {
    getGPFNRData();
  }, [userId]);

  const handleInputChange = (name, marathiValue, englishValue) => {
    if (name === "gpfNumber" || name === "baseSalary") {
      setFormData((prev) => ({
        ...prev,
        [name]: englishValue, // Marathi EditTransliteration
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: marathiValue, // Marathi EditTransliteration
      }));
    }
    setFormData2((prev) => ({
      ...prev,
      [name]: englishValue, // English input
    }));
  };

  const handleBankInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormData2({ ...formData2, [name]: value });
  };

  const handleInputDateChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      ["retirementDate"]: moment(value).format("DD-MMM-YYYY"),
    }));
    setFormData2((prevData) => ({
      ...prevData,
      ["retirementDate"]: moment(value).format("DD-MMM-YYYY"),
    }));
  };
  const handleInputDOBDateChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      ["dob"]: moment(value).format("DD-MMM-YYYY"),
    }));
    setFormData2((prevData) => ({
      ...prevData,
      ["dob"]: moment(value).format("DD-MMM-YYYY"),
    }));
  };

  const handleInputAppoDateChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      ["firstAppointmentDate"]: moment(value).format("DD-MMM-YYYY"),
    }));
    setFormData2((prevData) => ({
      ...prevData,
      ["firstAppointmentDate"]: moment(value).format("DD-MMM-YYYY"),
    }));
  };

  const handleSalaryDateChange = (value) => {
    setToDate(moment(value).format("MMM-YYYY"));
    setFormData((prevData) => ({
      ...prevData,
      ["salaryMonth"]: moment(value).format("MMM-YYYY"),
    }));
    setFormData2((prevData) => ({
      ...prevData,
      ["salaryMonth"]: moment(value).format("MMM-YYYY"),
    }));
  };

  // Function to calculate service duration
  const calculateServiceDuration = (firstAppointmentDate) => {
    if (!firstAppointmentDate) return "";

    const startDate = new Date(firstAppointmentDate);
    const endDate = new Date(); // Current date

    const years = endDate.getFullYear() - startDate.getFullYear();
    const months = endDate.getMonth() - startDate.getMonth();
    const days = endDate.getDate() - startDate.getDate();

    let adjustedMonths = months;
    let adjustedDays = days;

    if (days < 0) {
      adjustedMonths -= 1;
      adjustedDays += new Date(
        endDate.getFullYear(),
        endDate.getMonth(),
        0
      ).getDate(); // Days in previous month
    }

    if (months < 0) {
      adjustedMonths += 12;
    }

    return `${years} वर्ष, ${adjustedMonths} महिने, ${adjustedDays} दिवस`;
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangee = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setFormData2({ ...formData2, [name]: value });
  };

  // 2
  const calculateGrossPayableSalary = () => {
    const fields = [
      "basicPay",
      "dearnessAllowance",
      "houseRentAllowance",
      "transportAllowance",
      "permanentTravelAllowance",
      "dearnessDifference",
      "seventhPayInstallment",
      "washingAllowance",
      "basicArrears",
      "other1",
      "other2",
    ];
    return fields.reduce(
      (total, field) => total + parseFloat(formData[field] || 0),
      0
    );
  };

  const calculateTotalDeductions = () => {
    const fields = [
      "professionTax",
      "groupInsurance",
      "bhininiVargani",
      "festivalAdvance",
      "lic",
      "gppatSanstha",
      "arogyapatSanstha",
      "gramsevakPatSanstha",
      "groupInsuranceHomeLoan",
      "receiptTicket",
    ];
    return fields.reduce(
      (total, field) => total + parseFloat(formData[field] || 0),
      0
    );
  };

  useEffect(() => {
    const grossPayableSalary = calculateGrossPayableSalary();
    const totalDeductions = calculateTotalDeductions();
    const netPaySalary = grossPayableSalary - totalDeductions;

    console.log(grossPayableSalary);

    // Update formData and formData2 in a single call each
    setFormData({
      ...formData,
      grossPayableSalary,
      totalDeductions,
      netPaySalary,
    });

    setFormData2({
      ...formData2,
      grossPayableSalary,
      totalDeductions,
      netPaySalary,
    });
  }, [formData.basicPay]);

  const calculateNetPay = () => {
    const grossPayableSalary = calculateGrossPayableSalary();
    const totalDeductions = calculateTotalDeductions();
    return grossPayableSalary - totalDeductions;
  };

  // 3
  const [deductionData, setDeductionData] = useState({
    employeeName: formData.applicantName,
    gpfNumber: formData.gpfNumber,
    monthlyData: [
      { month: "Apr-24", amount: 0, contribution: 0, total: 0 },
      { month: "May-24", amount: 0, contribution: 0, total: 0 },
      { month: "Jun-24", amount: 0, contribution: 0, total: 0 },
      { month: "Jul-24", amount: 0, contribution: 0, total: 0 },
      { month: "Aug-24", amount: 0, contribution: 0, total: 0 },
      { month: "Sep-24", amount: 0, contribution: 0, total: 0 },
      { month: "Oct-24", amount: 0, contribution: 0, total: 0 },
      { month: "Nov-24", amount: 0, contribution: 0, total: 0 },
      { month: "Dec-24", amount: 0, contribution: 0, total: 0 },
      { month: "Jan-25", amount: 0, contribution: 0, total: 0 },
      { month: "Feb-25", amount: 0, contribution: 0, total: 0 },
      { month: "Mar-25", amount: 0, contribution: 0, total: 0 },
      { month: "Apr-25", amount: 0, contribution: 0, total: 0 },
      { month: "May-25", amount: 0, contribution: 0, total: 0 },
      { month: "Jun-25", amount: 0, contribution: 0, total: 0 },
    ],
    totalContributions: {
      amount: 0,
      contribution: 0,
      total: 0,
    },
  });

  const handleTotalContributions = (month, field, value) => {
    setDeductionData((prevData) => {
      const updatedMonthlyData = prevData.monthlyData.map((item) => {
        if (item.month === month) {
          const updatedItem = { ...item, [field]: parseFloat(value) || 0 };
          updatedItem.total = updatedItem.amount + updatedItem.contribution; // Calculate total
          return updatedItem;
        }
        return item;
      });

      // Calculate new totals
      const totalAmount = updatedMonthlyData.reduce(
        (sum, item) => sum + item.amount,
        0
      );
      const totalContribution = updatedMonthlyData.reduce(
        (sum, item) => sum + item.contribution,
        0
      );
      const grandTotal = totalAmount + totalContribution;

      // Update deductionData
      return {
        ...prevData,
        monthlyData: updatedMonthlyData,
        totalContributions: {
          amount: totalAmount,
          contribution: totalContribution,
          total: grandTotal,
        },
      };
    });
  };

  const [field1, setField1] = useState(0); // First value
  const [field2, setField2] = useState(deductionData.totalContributions.total); // Second value
  const [field3, setField3] = useState(0); // Third value
  const [field4, setField4] = useState(0); // Fifth value
  const [field5, setField5] = useState(0); // Seventh value
  const [field6, setField6] = useState(0); // Eighth value
  // Automatically update service duration when first appointment date changes
  useEffect(() => {
    const duration = calculateServiceDuration(formData.firstAppointmentDate);
    setFormData((prevData) => ({
      ...prevData,
      serviceDuration: duration,
    }));
    setFormData2((prevData) => ({
      ...prevData,
      serviceDuration: duration,
    }));
  }, [formData.firstAppointmentDate]);

  useEffect(() => {
    try {
      if (GPFNRData?.deductionData) {
        setDeductionData(JSON.parse(GPFNRData.deductionData));
      }
      if (GPFNRData?.formData) {
        setFormData(JSON.parse(GPFNRData.formData));
      }
      if (GPFNRData?.formData2) {
        setFormData2(JSON.parse(GPFNRData.formData2));
      }
      if (GPFNRData?.field1) {
        setField1(GPFNRData.field1);
      }
      if (GPFNRData?.field2) {
        setField2(GPFNRData.field2);
      }
      if (GPFNRData?.field3) {
        setField3(GPFNRData.field3);
      }
      if (GPFNRData?.field4) {
        setField4(GPFNRData.field4);
      }
      if (GPFNRData?.field5) {
        setField5(GPFNRData.field5);
      }
      if (GPFNRData?.field6) {
        setField6(GPFNRData.field6);
      }
    } catch (error) {
      console.error("Error parsing JSON data:", error);
    }
  }, [GPFNRData]);

  const totalField4 =
    parseFloat(field1) +
    parseFloat(deductionData.totalContributions.total) +
    parseFloat(field3); // Field 4
  const remainingField6 = totalField4 - parseFloat(field5); // Field 6 (remaining after subtracting field 5)

  const updateGPFNR = async () => {
    try {
      const response = await fetch(`${api_url}/api/users/update-gpfnr-data`, {
        method: "POST",
        body: JSON.stringify({
          data_id: GPFNRData._id,
          formData,
          formData2,
          deductionData,
          field1,
          field2: deductionData.totalContributions.total,
          totalField4,
          field3,
          remainingField6,
          field4,
          field5,
          field6,
          empName: formData.applicantName,
          empMobile: formData.mobileNumber,
          gpfNumber: formData.gpfNumber,
          empDesignation: formData.designation,
          officeName: formData.officeName,
          usersAdminId: userId,
        }),
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      });
      const result = await response.json();
      console.log(result);
      if (result.status === 201) {
        toast.success(result.message);
        navigate("/dashboard/gpf_non_refundable_work");
      } else {
        toast.error(result.message);
      }
    } catch (error) {
      alert(error);
    }
  };

  console.log(formData);
  console.log(formData2);

  return (
    <div className="gpfnr-page px-5 py-3">
      <div className="row">
        <div className="col-lg-10">
          <div className="w-100 mx-auto p-4 mt-3 bg-info rounded-md shadow-xl gpfnr-input">
            <div className="row">
              <div className="col-lg-12">
                <h2 className="text-lg sm:text-xl font-bold text-blue-700">
                  Edit
                </h2>
              </div>
              <div className="col-lg-12">
                <h2 className="text-lg sm:text-xl font-bold mb-4 text-center text-blue-700">
                  भविष्य निर्वाह निधी (ना - परतावा ) प्रस्ताव तयार करणे
                </h2>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row border-b-2 gap-3 my-3">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentStep(index)}
                  className={` py-2 px-4 text-xs sm:text-sm w-25 font-semibold text-center 
              ${
                currentStep === index
                  ? "bg-teal-600 text-white"
                  : "bg-orange-100 text-gray-800"
              }
              hover:bg-teal-600 hover:text-white transition-all`}
                >
                  {tab}
                </button>
              ))}
            </div>

            {currentStep === 0 && (
              <div>
                <div className="card p-3 ">
                  <h4 className="mb-3 fw-bold text-danger">
                    अर्जदाराची माहिती{" "}
                  </h4>

                  <div className="row g-2">
                    <div className="col-lg-6 col-12 px-1">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        अर्जदाराचे नाव
                      </label>
                      <EditTransliteration
                        name="applicantName"
                        fromDataEnglish={formData2.applicantName}
                        fromDataMarathi={formData.applicantName}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="col-lg-6 col-12 px-1">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        पदनाम
                      </label>
                      <EditTransliteration
                        name="designation"
                        fromDataEnglish={formData2.designation}
                        fromDataMarathi={formData.designation}
                        onChange={handleInputChange}
                      />
                    </div>

                    <div className="col-lg-2 col-4">
                      <FormInput
                        label="भ.नि.नि. क्रमांक"
                        name="gpfNumber"
                        fontFamily={"Arial"}
                        fontSize={"16px"}
                        value={formData.gpfNumber}
                        onChange={(e) =>
                          handleInputChange(
                            "gpfNumber",
                            e.target.value,
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-lg-2 col-4">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        वेतन श्रेणी
                      </label>
                      <select
                        id="salaryRange"
                        name="salaryRange"
                        onChange={(e) =>
                          handleInputChange(
                            "salaryRange",
                            e.target.value,
                            e.target.value
                          )
                        }
                        className="form-control form-select"
                        required
                      >
                        <option value={formData.salaryRange}>
                          {formData.salaryRange}
                        </option>
                        <option value="S-1 : 15000-47600">
                          S-1 : 15000-47600
                        </option>
                        <option value="S-2 : 15300-48700">
                          S-2 : 15300-48700
                        </option>
                        <option value="S-3 : 16600-52400">
                          S-3 : 16600-52400
                        </option>
                        <option value="S-4 : 17100-54000">
                          S-4 : 17100-54000
                        </option>
                        <option value="S-5 : 18000-56900">
                          S-5 : 18000-56900
                        </option>
                        <option value="S-6 : 19900-63200">
                          S-6 : 19900-63200
                        </option>
                        <option value="S-7 : 21700-69100">
                          S-7 : 21700-69100
                        </option>
                        <option value="S-8 : 25500-81100">
                          S-8 : 25500-81100
                        </option>
                        <option value="S-9 : 26400-83600">
                          S-9 : 26400-83600
                        </option>
                        <option value="S-10 : 29200-92300">
                          S-10 : 29200-92300
                        </option>
                        <option value="S-11 : 30100-95100">
                          S-11 : 30100-95100
                        </option>
                        <option value="S-12 : 32000-101600">
                          S-12 : 32000-101600
                        </option>
                        <option value="S-13 : 35400-112400">
                          S-13 : 35400-112400
                        </option>
                        <option value="S-14 : 38600-122800">
                          S-14 : 38600-122800
                        </option>
                        <option value="S-15 : 41800-132300">
                          S-15 : 41800-132300
                        </option>
                        <option value="S-16 : 44900-142400">
                          S-16 : 44900-142400
                        </option>
                        <option value="S-17 : 47600-151100">
                          S-17 : 47600-151100
                        </option>
                        <option value="S-18 : 49100-155800">
                          S-18 : 49100-155800
                        </option>
                        <option value="S-19 : 55100-175100">
                          S-19 : 55100-175100
                        </option>
                        <option value="S-20 : 56100-177500">
                          S-20 : 56100-177500
                        </option>
                        <option value="S-21 : 57100-180800">
                          S-21 : 57100-180800
                        </option>
                        <option value="S-22 : 60000-190800">
                          S-22 : 60000-190800
                        </option>
                        <option value="S-23 : 67700-208700">
                          S-23 : 67700-208700
                        </option>
                        <option value="S-24 : 71100-211900">
                          S-24 : 71100-211900
                        </option>
                        <option value="S-25 : 78800-209200">
                          S-25 : 78800-209200
                        </option>
                        <option value="S-27 : 118500-214100">
                          S-27 : 118500-214100
                        </option>
                        <option value="S-28 : 124800-212400">
                          S-28 : 124800-212400
                        </option>
                        <option value="S-29 : 131100-216600">
                          S-29 : 131100-216600
                        </option>
                      </select>
                    </div>
                    <div className="col-lg-2 col-4">
                      <FormInput
                        label="मूळ वेतन"
                        name="baseSalary"
                        fontFamily={"Arial"}
                        fontSize={"16px"}
                        value={formData.baseSalary}
                        onChange={(e) =>
                          handleInputChange(
                            "baseSalary",
                            e.target.value,
                            e.target.value
                          )
                        }
                      />
                    </div>
                    <div className="col-lg-6 col-8">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        अग्रीम घेण्याचे कारण
                      </label>
                      <EditTransliteration
                        name="reasonForAdvance"
                        fromDataEnglish={formData2.reasonForAdvance}
                        fromDataMarathi={formData.reasonForAdvance}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div>
                        <label className="block text-sm font-black text-gray-700 mb-2">
                          जन्म दिनांक
                        </label>
                        <DatePicker
                          selected={formData.dob}
                          onChange={(date) => handleInputDOBDateChange(date)}
                          dateFormat="dd-MMM-yyyy" // Built-in format for DD-MMM-YYYY
                          className="form-control"
                          showMonthDropdown // Enables month dropdown
                          showYearDropdown // Enables year dropdown
                          dropdownMode="select" // Allows selection instead of scrolling
                        />
                      </div>
                      {/* <FormInput label="जन्म दिनांक" name="dob" value={formData.dob} type="date" onChange={handleInputChange} /> */}
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div>
                        <label className="block text-sm font-black text-gray-700 mb-2">
                          प्रथम नेमणूक दिनांक
                        </label>
                        <DatePicker
                          selected={formData.firstAppointmentDate}
                          onChange={(date) => handleInputAppoDateChange(date)}
                          dateFormat="dd-MMM-yyyy" // Built-in format for DD-MMM-YYYY
                          className="form-control"
                          showMonthDropdown // Enables month dropdown
                          showYearDropdown // Enables year dropdown
                          dropdownMode="select" // Allows selection instead of scrolling
                        />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                      <div>
                        <label className="block text-sm font-black text-gray-700 mb-2">
                          सेवा निवृत्ती दिनांक
                        </label>
                        <DatePicker
                          selected={formData.retirementDate}
                          onChange={(date) => handleInputDateChange(date)}
                          dateFormat="dd-MMM-yyyy" // Built-in format for DD-MMM-YYYY
                          className="form-control"
                          showMonthDropdown // Enables month dropdown
                          showYearDropdown // Enables year dropdown
                          dropdownMode="select" // Allows selection instead of scrolling
                        />
                      </div>
                      {/* <FormInput label="सेवा निवृत्ती दिनांक (dd/mm/yyyy)" name="retirementDate" value={formData.retirementDate} type="date" onChange={handleInputChange} /> */}
                    </div>

                    <div className="col-lg-3 col-md-6">
                      <FormInput
                        label="आज रोजी झालेली सेवा"
                        name="serviceDuration"
                        value={formData.serviceDuration}
                        readOnly
                        fontFamily={"Arial"}
                        fontSize={"16px"}
                      />
                    </div>
                  </div>
                </div>
                <div className="card p-3  mt-3">
                  <h4 className="mb-3 fw-bold text-danger">
                    कार्यालयाची माहिती{" "}
                  </h4>

                  <div className="row g-2">
                    <div className="col-lg-6 col-12">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        कार्यालयाचे नाव
                      </label>
                      <EditTransliteration
                        name="officeName"
                        fromDataEnglish={formData2.officeName}
                        fromDataMarathi={formData.officeName}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="col-lg-6 col-12">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        कार्यालय प्रमुखाचे पदनाम
                      </label>
                      <EditTransliteration
                        name="officeHeadDesignation"
                        fromDataEnglish={formData2.officeHeadDesignation}
                        fromDataMarathi={formData.officeHeadDesignation}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="col-lg-4 col-12">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        कार्यालयाचा जावक क्रमांक
                      </label>
                      <EditTransliteration
                        name="officeSerialNumber"
                        fromDataEnglish={formData2.officeSerialNumber}
                        fromDataMarathi={formData.officeSerialNumber}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="col-lg-3 col-12">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        मंजूर करणाऱ्या विभागाचे नाव
                      </label>
                      <input
                        type="text"
                        name="approvingDepartmentName"
                        value={formData.approvingDepartmentName}
                        readOnly
                        className="form-control"
                      />
                    </div>

                    <div className="col-lg-5 col-12">
                      <label className="block text-sm font-black text-gray-700 mb-2">
                        मंजुरीसाठी कोणत्या कार्यालयास सादर करायचे आहे
                      </label>
                      <EditTransliteration
                        name="submissionOffice"
                        fromDataEnglish={formData2.submissionOffice}
                        fromDataMarathi={formData.submissionOffice}
                        onChange={handleInputChange}
                      />
                    </div>
                  </div>
                </div>

                <div className="card p-3 mt-3">
                  <h4 className="mb-3 fw-bold text-danger">बँकेचा तपशील</h4>
                  <div className="row g-2 mt-1">
                    <div className="col-lg-4 col-6">
                      <FormInput
                        label="बँकेचे नाव"
                        name="bankName"
                        value={formData.bankName}
                        onChange={handleBankInputChange}
                        fontFamily={"Arial"}
                        fontSize={"16px"}
                      />
                    </div>
                    <div className="col-lg-4 col-6">
                      <FormInput
                        label="शाखेचे नाव"
                        name="branchName"
                        value={formData.branchName}
                        onChange={handleBankInputChange}
                        fontFamily={"Arial"}
                        fontSize={"16px"}
                      />
                    </div>
                    <div className="col-lg-4 col-6">
                      <FormInput
                        label="IFSC Code"
                        name="ifscCode"
                        value={formData.ifscCode}
                        onChange={handleBankInputChange}
                        fontFamily={"Arial"}
                        fontSize={"16px"}
                      />
                    </div>
                    <div className="col-lg-4 col-6">
                      <FormInput
                        label="खाते क्रमांक"
                        name="accountNumber"
                        value={formData.accountNumber}
                        onChange={handleBankInputChange}
                        fontFamily={"Arial"}
                        fontSize={"16px"}
                      />
                    </div>
                    <div className="col-lg-4 col-6">
                      <FormInput
                        label="मोबाईल नंबर"
                        name="mobileNumber"
                        value={formData.mobileNumber}
                        onChange={handleBankInputChange}
                        fontFamily={"Arial"}
                        fontSize={"16px"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="p-4 bg-blue-50 rounded-md shadow-md">
              {currentStep === 1 && (
                <div className="container mx-auto bg-blue-50 px-3 pt-1 pb-4 rounded">
                  <div className="row mb-3">
                    <div className="col-lg-8 col-12 mt-lg-0 mt-3 ps-0">
                      <h1 className="text-left text-red-600 text-xl font-bold mb-4">
                        वेतन प्रमाणपत्र (Pay Slip)
                      </h1>
                    </div>
                    <div className="col-lg-4 col-12 mt-lg-0 mt-3">
                      <div className="d-flex justify-between align-items-center">
                        <label className="text-danger fw-bold w-50">
                          महिना :-{" "}
                        </label>
                        <DatePicker
                          selected={toDate}
                          onChange={(date) => handleSalaryDateChange(date)}
                          dateFormat="MMM-yyyy" // Built-in format for DD-MMM-YYYY
                          className="form-control"
                          showMonthDropdown // Enables month dropdown
                          showYearDropdown // Enables year dropdown
                          dropdownMode="select" // Allows selection instead of scrolling
                          showMonthYearPicker // Enables Month-Year Picker
                          showFullMonthYearPicker // Optional: Shows full month and year in the dropdown
                        />
                      </div>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                    {/* Left Column */}
                    <div className="flex flex-col gap-2">
                      {[
                        { label: "मूळ वेतन", name: "basicPay" },
                        { label: "महागाई भत्ता", name: "dearnessAllowance" },
                        { label: "घरभाडे", name: "houseRentAllowance" },
                        { label: "वाहतूक भत्ता", name: "transportAllowance" },
                        {
                          label: "कायम प्रवास भत्ता",
                          name: "permanentTravelAllowance",
                        },
                        // { label: "NPS", name: "nps" },
                        {
                          label: "महागाई भत्ता फरक",
                          name: "dearnessDifference",
                        },
                        {
                          label: "7 वा वेतन आयोग हफ्ता",
                          name: "seventhPayInstallment",
                        },
                        { label: "धुलाई भत्ता", name: "washingAllowance" },
                        { label: "बेसीक arrears", name: "basicArrears" },
                        { label: "Other-1", name: "other1" },
                        { label: "Other-2", name: "other2" },
                        {
                          label: "एकूण देय वेतन",
                          name: "grossPayableSalary",
                          isHighlighted: true,
                        },
                      ].map(({ label, name, isHighlighted }) => (
                        <div
                          key={name}
                          className="flex justify-between items-center gap-4"
                        >
                          <label
                            className={`font-semibold ${
                              isHighlighted ? "text-red-600" : ""
                            }`}
                          >
                            {label}
                          </label>
                          <input
                            type="text"
                            style={{ fontFamily: "Arial", fontSize: "16px" }}
                            name={name}
                            value={
                              name === "grossPayableSalary"
                                ? calculateGrossPayableSalary()
                                : formData[name]
                            }
                            onChange={handleChangee}
                            className="form-control w-50"
                            placeholder="Enter value"
                            readOnly={name === "grossPayableSalary"}
                          />
                        </div>
                      ))}
                    </div>

                    {/* Right Column */}
                    <div className="flex flex-col gap-2">
                      {[
                        { label: "व्यवसाय कर", name: "professionTax" },
                        { label: "गट विमा", name: "groupInsurance" },
                        { label: "भ.नि.नि. वर्गणी", name: "bhininiVargani" },
                        { label: "सण अग्रिम", name: "festivalAdvance" },
                        // { label: "DCPS", name: "dcps" },
                        // { label: "NPS (कपात)", name: "npsDeduction" },
                        { label: "एल आय सी", name: "lic" },
                        { label: "जी प पतसंस्था", name: "gppatSanstha" },
                        { label: "आरोग्य पतसंस्था", name: "arogyapatSanstha" },
                        {
                          label: "ग्रामसेवक पतसंस्था",
                          name: "gramsevakPatSanstha",
                        },
                        {
                          label: "गटविमा गृहकर्ज",
                          name: "groupInsuranceHomeLoan",
                        },
                        { label: "रशीद तिकीट", name: "receiptTicket" },
                        {
                          label: "एकूण कपात वेतन",
                          name: "totalDeductions",
                          isHighlighted: true,
                        },
                        {
                          label: "निव्वळ देय वेतन",
                          name: "netPaySalary",
                          isHighlighted: true,
                        },
                      ].map(({ label, name, isHighlighted }) => (
                        <div
                          key={name}
                          className="flex justify-between items-center gap-4"
                        >
                          <label
                            className={`font-semibold ${
                              isHighlighted ? "text-red-600" : ""
                            }`}
                          >
                            {label}
                          </label>
                          <input
                            type="text"
                            name={name}
                            style={{ fontFamily: "Arial", fontSize: "16px" }}
                            value={
                              name === "netPaySalary"
                                ? calculateNetPay()
                                : name === "totalDeductions"
                                ? calculateTotalDeductions()
                                : formData[name]
                            }
                            onChange={handleChangee}
                            className="form-control w-50"
                            placeholder="Enter value"
                            readOnly={
                              name === "netPaySalary" ||
                              name === "totalDeductions"
                            }
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {currentStep === 2 && (
                <div className="overflow-x-auto bg-white p-4 rounded-lg shadow">
                  <div className="text-center font-semibold mb-4">
                    <h2 className="text-lg">
                      मुख्य लेखा व वित्त अधिकारी यांनी प्रमाणित केलेल्या वार्षिक
                      जमेवरुन जमा झालेल्या रकमेचा तपशिल
                    </h2>
                  </div>

                  <div className="flex flex-wrap justify-between mb-4">
                    <div className="text-sm">
                      <span className="font-semibold">
                        अर्जदाराचे नाव :- {formData.applicantName}
                      </span>
                    </div>
                    <div className="text-sm">
                      <span className="font-semibold">
                        भ नि नि क्रमांक :- {formData.gpfNumber}{" "}
                      </span>
                    </div>
                  </div>

                  <div className="overflow-x-auto">
                    <table className="min-w-full text-sm border-collapse">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border p-2 text-center" rowSpan={2}>
                            अक्र
                          </th>
                          <th className="border p-2 text-center" rowSpan={2}>
                            महिना
                          </th>
                          <th className="border p-2 text-center" rowSpan={2}>
                            वर्गणी
                          </th>
                          <th
                            className="border p-2 text-center flex-nowrap"
                            style={{ textWrap: "nowrap" }}
                            rowSpan={2}
                          >
                            वेतन आयोग हप्ता
                          </th>
                          <th className="border p-2 text-center" rowSpan={2}>
                            एकूण
                          </th>
                          <th
                            className="border p-2 text-center flex-nowrap"
                            style={{ textWrap: "nowrap" }}
                            rowSpan={2}
                          >
                            कर्ज परत रक्कम
                          </th>
                          <th className="border p-2 text-center" colSpan={3}>
                            घेतलेले कर्ज
                          </th>
                        </tr>
                        <tr>
                          <th className="border p-2 text-center">रक्कम </th>
                          <th
                            className="border p-2 text-center flex-nowrap"
                            style={{ textWrap: "nowrap" }}
                          >
                            चेक क्र.{" "}
                          </th>
                          <th className="border p-2 text-center">दिनांक</th>
                        </tr>
                      </thead>
                      <tbody>
                        {deductionData.monthlyData.map((row, index) => (
                          <tr key={index} className="hover:bg-gray-50">
                            <td className="border p-2 text-center">
                              {index + 1}
                            </td>
                            <td
                              className="border p-2"
                              style={{ textWrap: "nowrap" }}
                            >
                              {row.month}
                            </td>
                            <td className="border p-2 text-right">
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                defaultValue={row.amount}
                                onChange={(e) =>
                                  handleTotalContributions(
                                    row.month,
                                    "amount",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td className="border p-2 text-right">
                              <input
                                type="number"
                                className="form-control form-control-sm"
                                defaultValue={row.contribution}
                                onChange={(e) =>
                                  handleTotalContributions(
                                    row.month,
                                    "contribution",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td className="border p-2 text-right">
                              {row.total}
                            </td>
                            <td className="border p-2"></td>
                            <td className="border p-2"></td>
                            <td className="border p-2"></td>
                            <td className="border p-2"></td>
                          </tr>
                        ))}
                        <tr className="font-semibold bg-gray-100">
                          <td
                            colSpan="2"
                            className="border p-2"
                            style={{ textWrap: "nowrap" }}
                          >
                            एकूण जमा रक्कम
                          </td>
                          <td className="border p-2 text-right">
                            {deductionData.totalContributions.amount}
                          </td>
                          <td className="border p-2 text-right">
                            {deductionData.totalContributions.contribution}
                          </td>
                          <td className="border p-2 text-right">
                            {deductionData.totalContributions.total}
                          </td>
                          <td className="border p-2"></td>
                          <td className="border p-2"></td>
                          <td className="border p-2"></td>
                          <td className="border p-2"></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="flex flex-col md:flex-row mt-4 text-sm">
                    {/* Left side: Stamp and other details */}
                    <div className="flex flex-col items-center justify-between p-4 border border-gray-300 w-full md:w-1/3">
                      {/* Stamp Placeholder */}
                      <div className="w-32 h-32  flex items-center justify-center text-gray-500"></div>

                      {/* Below stamp text */}
                      <div className="text-center mt-4 space-y-2">
                        <div>{formData.officeHeadDesignation}</div>
                        <div className="font-bold">{formData.officeName}</div>
                      </div>
                    </div>

                    {/* Right side: Form content */}
                    <div className="flex-grow ml-0 md:ml-4 p-3 md:mt-0 space-y-4 card">
                      {/* 1st Field (Editable) */}
                      <div className="flex justify-between items-center">
                        <span className="text-red-600 font-semibold">
                          {" "}
                          1. मा.मु.ले. व वि.अ. यांनी सन २०२३-२४ <br /> मध्ये
                          प्रमाणित केलेली रक्कम
                        </span>
                        <input
                          type="number"
                          value={field1}
                          onChange={(e) => setField1(e.target.value)}
                          className="text-red-600 font-semibold border rounded px-2 w-40 md:w-36"
                        />
                      </div>

                      {/* 2nd Field (Editable) */}
                      <div className="flex justify-between items-center">
                        <span> 2. चालू वर्षात मासिक हप्त्याचे जमा रक्कम</span>
                        <input
                          type="number"
                          value={deductionData.totalContributions.total}
                          className="font-semibold border rounded px-2 w-40 md:w-36"
                          readOnly
                        />
                      </div>

                      {/* 3rd Field (Editable) */}
                      <div className="flex justify-between items-center">
                        <span className="text-red-600 font-semibold">
                          {" "}
                          3. सातवा वेतन आयोग ५ वा जमा हप्ता
                        </span>
                        <input
                          type="number"
                          value={field3}
                          onChange={(e) => setField3(e.target.value)}
                          className="text-red-600 font-semibold border rounded px-2 w-40 md:w-36"
                        />
                      </div>

                      {/* 4th Field (Calculated) */}
                      <div className="flex justify-between items-center">
                        <span> 4. एकूण खात्यावर जमा असलेली रक्कम</span>
                        <span className="font-semibold border rounded px-2 w-40 md:w-36 ">
                          {totalField4.toFixed(2)}
                        </span>
                      </div>

                      {/* 5th Field (Editable) */}
                      <div className="flex justify-between items-center">
                        <span> 5 . उपरोक्त कालावधीत घेतलेले कर्ज</span>
                        <input
                          type="number"
                          value={field4}
                          onChange={(e) => setField4(e.target.value)}
                          className="font-semibold border rounded px-2 w-40 md:w-36"
                        />
                      </div>

                      {/* 6th Field (Calculated) */}
                      <div className="flex justify-between items-center">
                        <span> 6. अर्जदाराचे खाती शिल्लक शिल्लक रक्कम</span>
                        <span className="font-semibold border rounded px-2 w-40 md:w-36 ">
                          {remainingField6.toFixed(2)}
                        </span>
                      </div>

                      {/* 7th Field (Editable) */}
                      <div className="flex justify-between items-center">
                        <span>
                          {" "}
                          7. पूर्वीच्या कर्जाची येणे बाकी असलेली रक्कम
                        </span>
                        <input
                          type="number"
                          value={field5}
                          onChange={(e) => setField5(e.target.value)}
                          className="font-semibold border rounded px-2 w-40 md:w-36"
                        />
                      </div>

                      {/* 8th Field (Editable) */}
                      <div className="flex justify-between items-center">
                        <span> 8. आता मागणी केलेले कर्ज (जमा रक्कम * ३/४)</span>
                        <input
                          type="number"
                          value={field6}
                          onChange={(e) => setField6(e.target.value)}
                          className="font-semibold border rounded px-2 w-40 md:w-36"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex justify-between mt-4">
              <button
                onClick={() => setCurrentStep((prev) => Math.max(prev - 1, 0))}
                disabled={currentStep === 0}
                className="bg-blue-300 text-gray-800 px-4 py-2 rounded-lg disabled:opacity-50"
              >
                मागील
              </button>
              {currentStep === tabs.length - 1 ? (
                <button
                  onClick={updateGPFNR}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg"
                >
                  Save
                </button>
              ) : (
                <button
                  onClick={() =>
                    setCurrentStep((prev) =>
                      Math.min(prev + 1, tabs.length - 1)
                    )
                  }
                  disabled={currentStep === tabs.length - 1}
                  className="bg-blue-600 text-white px-4 py-2 rounded-lg"
                >
                  पुढे
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const FormInput = ({
  label,
  name,
  value,
  onChange,
  type = "text",
  fontFamily,
  fontSize,
}) => (
  <div className="gpfnr-input">
    <label className="block text-sm font-black text-gray-700 mb-2">
      {label}
    </label>
    <input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      className="form-control"
      lang="mr"
      style={{ fontFamily: fontFamily, fontSize: fontSize }}
    />
  </div>
);

export default EditGPFNonRefundable;
